export const environment = {
  url: 'https://fodimi.pl',
  production: true,
  GOOGLE_MAPS_API_KEY: 'AIzaSyDpgQMpcfx1QU-8SM-ljcgjG4xrYtIYby4',
  ONESIGNAL_APP_ID: 'baf8297d-51b8-44d9-9e4c-4ffa8788dcc1',
  STRIPE_KEY: 'pk_live_51KTYRcE8WllBVykF5ZPnYuVRV5P4qxe2NzD0E4zzd8PiF4nmLzEv8EOXaoOvmGs0TZw7R5APop7Ehn6qzT4vZVVO00hR3bMHXB',
};
